// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"be11c041","99":"cf343c09","224":"86c0ab9a","640":"44a7127b","940":"b1a31586"}[chunkId] + ".chunk.js";
};